import { useState } from 'react';
import axios from 'axios';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  Stack,
  Checkbox,
  Text,
  useToast,
  VStack,
  useColorModeValue
} from '@chakra-ui/react';
import { setToken, setRefreshToken, setUserType, setAccountId } from '../utils/authService';

const LoginModal = ({ isOpen, onClose, setIsLoggedIn, onLoginSuccess, onSignUp }) => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const toast = useToast();
  const bgColor = useColorModeValue("white", "black");


  const handleLogin = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const backendUrl = process.env.NODE_ENV === 'production'
        ? process.env.REACT_APP_BACKEND_URL
        : 'http://localhost:8080';
      
      const response = await axios.post(`${backendUrl}/login`, { email, password });
      const { token, refresh_token, account_id, user_type } = response.data;
      
      setToken(token);
      setRefreshToken(refresh_token);
      setUserType(user_type);
      setAccountId(account_id);
      setIsLoggedIn(true);
      toast({
        title: 'Login successful!',
        status: 'success',
        duration: 3000,
        isClosable: true,
      });

      onLoginSuccess(); // Call callback to trigger booking after login
      onClose(); // Close login modal
    } catch (error) {
      console.error('Error during login:', error);
      toast({
        title: 'Login failed.',
        description: 'Please check your credentials and try again.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered color={bgColor}>
      <ModalOverlay />
      <ModalContent bg={bgColor}>
        <ModalHeader textAlign="center">Sign In to Continue</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack as="form" spacing={4} onSubmit={handleLogin}>
            <FormControl id="email" isRequired>
              <FormLabel>Email address</FormLabel>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />
            </FormControl>
            <FormControl id="password" isRequired>
              <FormLabel>Password</FormLabel>
              <Input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
            </FormControl>
            <Stack direction="row" justify="space-between" width="100%">
              <Checkbox>Remember me</Checkbox>
              <Text color="blue.400">
                <a href={`mailto:papi@papirazzi.app?subject=Password Reset&body=Hello Papirazzi Support Team, I want to reset my password.`}>
                  Forgot password?
                </a>
              </Text>
            </Stack>
            <Button colorScheme="blue" type="submit" isLoading={isLoading} width="100%">
              Sign In
            </Button>
            <Text>
              Not a user?{" "}
              <Text as="span" color="blue.400" cursor="pointer" onClick={onSignUp}>
                Sign Up
              </Text>
            </Text>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default LoginModal;
